/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ResetPasswordUrlResponse
 */
export interface ResetPasswordUrlResponse {
  /**
   *
   * @type {string}
   * @memberof ResetPasswordUrlResponse
   */
  resetUrl: string;
}

/**
 * Check if a given object implements the ResetPasswordUrlResponse interface.
 */
export function instanceOfResetPasswordUrlResponse(
  value: object,
): value is ResetPasswordUrlResponse {
  if (!("resetUrl" in value) || value["resetUrl"] === undefined) return false;
  return true;
}

export function ResetPasswordUrlResponseFromJSON(
  json: any,
): ResetPasswordUrlResponse {
  return ResetPasswordUrlResponseFromJSONTyped(json, false);
}

export function ResetPasswordUrlResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResetPasswordUrlResponse {
  if (json == null) {
    return json;
  }
  return {
    resetUrl: json["resetUrl"],
  };
}

export function ResetPasswordUrlResponseToJSON(
  json: any,
): ResetPasswordUrlResponse {
  return ResetPasswordUrlResponseToJSONTyped(json, false);
}

export function ResetPasswordUrlResponseToJSONTyped(
  value?: ResetPasswordUrlResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    resetUrl: value["resetUrl"],
  };
}
